import { render, staticRenderFns } from "./SeparationFundRow.vue?vue&type=template&id=5ddf7292&scoped=true"
import script from "./SeparationFundRow.vue?vue&type=script&lang=js"
export * from "./SeparationFundRow.vue?vue&type=script&lang=js"
import style0 from "./SeparationFundRow.vue?vue&type=style&index=0&id=5ddf7292&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddf7292",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ddf7292')) {
      api.createRecord('5ddf7292', component.options)
    } else {
      api.reload('5ddf7292', component.options)
    }
    module.hot.accept("./SeparationFundRow.vue?vue&type=template&id=5ddf7292&scoped=true", function () {
      api.rerender('5ddf7292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/components/SeparationFundRow.vue"
export default component.exports